import React, { Component, PropTypes } from 'react';
import Form, { DateInput, FormActions, FormBody, SelectInput } from '../../Form';
import Button from '../../Form/Button';
import { inject, observer } from 'mobx-react';
import { observable, toJS } from 'mobx';
import * as api from '../api';
import moment from 'moment';
import Spinner from '../../Spinner';
import DataTable from '../../DataTable';
import Graph from './Graph';

@inject('stationStore', 'parameterStore')
@observer
class Interpolation extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  }

  componentWillMount() {
    const { stationStore, parameterStore } = this.props;
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!parameterStore.isLoading && !parameterStore.items.length) parameterStore.fetchItems();
  }

  @observable filters = {
    station_id: '4123',
    parameter_id: '151',
    date_from: moment().subtract(7, 'days').format('YYYY-MM-DDTHH:mm:ss'),
    date_to: moment().add(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
  }
  @observable items = [];
  @observable isLoading = false;
  @observable selectedItem = null;

  statusOptions = {
    '0': 'Reported',
    '1': 'Duplicate',
    '2': 'Corrected',
    '3': 'Rejected',
  }

  onChange = (e, key) => this.filters[key] = e.target.value;

  onView = (e) => {
    e.preventDefault();
    const { notify } = this.context;

    const payload = toJS(this.filters);
    this.isLoading = true;

    api.interpolation.fetch(payload)
      .then(res => {
        this.items = res.map(item => Object.assign({}, item, {
          statusOption: this.statusOptions[item.status.toString()],
          view: item.status == 2 ? <div className='action' onClick={() => this.selectedItem = item}><a>View</a></div> : null
        }));
      })
      .catch(err => {
        console.log(err);
        notify.error({ message: err.toString() });
      })
      .finally(() => this.isLoading = false);
  }

  render() {
    const { stationStore, parameterStore } = this.props;
  
    if (stationStore.isLoading || parameterStore.isLoading) return <Spinner />;

    const parameter = parameterStore.findById(this.filters.parameter_id);
    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='Station' value={this.filters.station_id} options={stationStore.items} fields={{ label: 'name', value: 'id' }} onChange={(e) => this.onChange(e, 'station_id')} />
            <SelectInput label='Parameter' value={this.filters.parameter_id} options={parameterStore.items} fields={{ label: 'name', value: 'id' }} onChange={(e) => this.onChange(e, 'parameter_id')} />
            <DateInput type='datetime-local' label='Date From' value={this.filters.date_from} onChange={(e) => this.onChange(e, 'date_from')} />
            <DateInput type='datetime-local' label='Date To' value={this.filters.date_to} onChange={(e) => this.onChange(e, 'date_to')} />
          </FormBody>
          <FormActions>
            <Button label='View' onClick={this.onView} />
          </FormActions>
        </Form>
        {this.isLoading && <Spinner />}
        {!!this.items.length && <DataTable
          data={this.items}
          slug={'tools/interpolation'}
          columns={[
            { key: 'id', label: 'Id' },
            { key: 'time', label: 'Time' },
            { key: 'timestamp', label: 'Correction Time' },
            { key: 'value', label: 'Value' },
            { key: 'corrected_value', label: 'Corrected Value' },
            { key: 'statusOption', label: 'Status' },
            { key: 'view', label: '' },
          ]}
        />}
        {!!this.selectedItem && <Graph item={toJS(this.selectedItem)} onClose={() => this.selectedItem = null} parameter={parameter} />}
      </div>
    );
  }
}

export default Interpolation;


// WEBPACK FOOTER //
// ./src/components/Tools/Interpolation/Interpolation.js